import sierraPic from "@/public/images/artists/sierra.jpg";
import { Artist } from "@/types/types";

export const sierra = {
  id: "114",
  name: "Sierra",
  image: sierraPic,
  description: `Sierra's voice bears soulful subtleties and dynamic phrasing, marked by a velvety, sultry timbre and a delivery that flows effortlessly. Her vocals exude a distinct warmth and intimacy tinged with a youthful exuberance.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fsierra-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["RnB", "Pop", "Unprocessed"],
      secondary: ["Youthful", "Wide Range"],
    },
    pitchRange: {
      categories: {
        low: "High",
        high: "High",
      },
      specific: {
        low: 59,
        high: 72,
      },
    },
  },
} as const satisfies Artist;
